export default __webpack_public_path__ + "static/media/m3-01.445eb43e.png";